import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Button, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { truncateText } from "utils/utils";
import { isEmpty } from "utils/utils";
import { FaSpinner } from "react-icons/fa";


function HomeCategoryModal({ setSelectCategoryId, setCurrentPage, setIsMegaMenuOpen, setSearchTemplate }) {
    const [mainCategories, setMainCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    const chunkArray = (arr, chunks) => {
        const perChunk = Math.ceil(arr.length / chunks);
        return Array.from({ length: chunks }, (v, i) =>
            arr.slice(i * perChunk, i * perChunk + perChunk)
        );
    };

    const getCategoryList = async () => {
        let params = {};
        setLoading(true);
        const { data } = await apiCall("post", apiEndPoint.GETHEADINGCATEGORYLIST, params);
        if (data.status === 200) {
            setMainCategories(data.data);
        } else {
            setMainCategories([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        getCategoryList();
    }, []);

    // Separate Blue-Collar & Service Providers
    const blueCollar = mainCategories.find(cat => cat.name === "Blue-Collar & Service Providers");
    const otherCategories = mainCategories.filter(cat => cat.name !== "Blue-Collar & Service Providers");

    // Chunk other categories
    const chunkedCategories = chunkArray(otherCategories, 4);

    return (
        <>
            {loading ? (
                <Spinner animation="border" size="md" />
            ) : (
                <div className="mega-menu-columns">
                    {chunkedCategories.map((column, columnIndex) => (
                        <ul key={columnIndex} className="mega-menu-column">
                            {column.map((item, i) => (
                                <li style={{ marginBottom: '1.5rem' }} key={i}>
                                    <h6 style={{ textAlign: 'left', fontWeight: 600 }}>
                                        {item?.name} <span>{">"}</span>
                                    </h6>
                                    {item.child.length > 0 &&
                                        item.child.map((chvalue, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setSelectCategoryId(chvalue?._id);
                                                    setCurrentPage(0);
                                                    setIsMegaMenuOpen(false);
                                                    setSearchTemplate(chvalue.category_name);
                                                }}
                                                style={{
                                                    marginBottom: 0,
                                                    fontWeight: 400,
                                                    fontSize: 15,
                                                    marginLeft: 8,
                                                }}
                                                className="mega-menu-item"
                                            >
                                                {chvalue.category_name}
                                            </p>
                                        ))}
                                </li>
                            ))}

                            {/* Append Blue-Collar only in the last column */}
                            {columnIndex === chunkedCategories.length - 1 && blueCollar && (
                                <li style={{ marginBottom: '1.5rem' }}>
                                    <h6 style={{ textAlign: 'left', fontWeight: 600 }}>
                                        {blueCollar?.name} <span>{">"}</span>
                                    </h6>
                                    {blueCollar.child.length > 0 &&
                                        blueCollar.child.map((chvalue, i) => (
                                            <p
                                                key={i}
                                                onClick={() => {
                                                    setSelectCategoryId(chvalue?._id);
                                                    setCurrentPage(0);
                                                    setIsMegaMenuOpen(false);
                                                    setSearchTemplate(chvalue.category_name);
                                                }}
                                                style={{
                                                    marginBottom: 0,
                                                    fontWeight: 400,
                                                    fontSize: 15,
                                                    marginLeft: 8,
                                                }}
                                                className="mega-menu-item"
                                            >
                                                {chvalue.category_name}
                                            </p>
                                        ))}
                                </li>
                            )}
                        </ul>
                    ))}
                </div>
            )}
        </>
    );
}

export default HomeCategoryModal;
